@if (week$ | async; as week) {
  <div class="layout-col full gap-xs">
    <app-daily-schedule-edit
      class="flex"
      [name]="'days.mo' | translate"
      [daySchedule]="week.monday"
    ></app-daily-schedule-edit>
    <app-daily-schedule-edit
      class="flex"
      [name]="'days.tu' | translate"
      [daySchedule]="week.tuesday"
    ></app-daily-schedule-edit>
    <app-daily-schedule-edit
      class="flex"
      [name]="'days.we' | translate"
      [daySchedule]="week.wednesday"
    ></app-daily-schedule-edit>
    <app-daily-schedule-edit
      class="flex"
      [name]="'days.th' | translate"
      [daySchedule]="week.thursday"
    ></app-daily-schedule-edit>
    <app-daily-schedule-edit
      class="flex"
      [name]="'days.fr' | translate"
      [daySchedule]="week.friday"
    ></app-daily-schedule-edit>
    <app-daily-schedule-edit
      class="flex"
      [name]="'days.sa' | translate"
      [daySchedule]="week.saturday"
    ></app-daily-schedule-edit>
    <app-daily-schedule-edit
      class="flex"
      [name]="'days.su' | translate"
      [daySchedule]="week.sunday"
    ></app-daily-schedule-edit>
  </div>
}
